import { memo, type FC, type ReactElement } from 'react';
import { ArrowShortRight, PersonDefault } from '@shared/assets';
import { useMobile } from '@shared/hooks';
import { IconButton } from '@shared/ui';
import * as st from './styles.module.scss';

interface Props {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  photo?: string;
  status?: () => ReactElement;
  onNavigate?: () => void;
}

export const Person: FC<Props> = memo(
  ({ firstName = '', middleName = '', lastName = '', photo, status, onNavigate }) => {
    const { isMobile } = useMobile();

    return (
      <section className={st.person}>
        <div className={st.person__content}>
          <div className={st.image}>
            {photo && <img src={photo} alt="" />}
            {!photo && <PersonDefault />}
          </div>
          <div className={st.text}>
            {!isMobile ? (
              <div className={st.text__title}>{`${lastName}  ${firstName} ${middleName}`}</div>
            ) : (
              <>
                <div className={st.text__title}>{`${lastName}`}</div>
                <div className={st.text__title}>{`${firstName}`}</div>
              </>
            )}
          </div>
        </div>
        {status && status()}
        <div className={st.person__navigate} onClick={onNavigate}>
          <IconButton variant="dark">
            <ArrowShortRight />
          </IconButton>
        </div>
      </section>
    );
  }
);
